export const dateConstants = {
    emptyDate: "1970-01-01T00:00:00.000Z",
    months :[
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
    am: "AM",
    pm: "PM"
}